import styles from './OnCallUserInfo.module.css';

interface IOnCallUserInfo {
  userName: string | null;
}

const OnCallUserInfo = ({ userName }: IOnCallUserInfo) => {
  return (
    <div className={styles.onCallUserContainer} data-testid={'onCallUserInfoDivTestId'}>
      {userName && <h2 className={styles.onCallUserText}>{`${userName}`} is on-call 📞</h2>}
    </div>
  );
};

export default OnCallUserInfo;
